import React from 'react';
import { joinClass } from '../helpers/component';
import SwapOption from './SwapOption';
import CustomerOwned from './CustomerOwned';

const SwapOptionGroup = ({
  className,
  devices = [],
  isCustomerOwned,
  hasNoLeasedDevice,
}) => (
  <div className={joinClass('swap-option-group', className)}>
    {devices.map(device => (
      <div className="swap-option-group__item" key={device.serialNumber}>
        {!isCustomerOwned && <SwapOption device={device} />}
        {isCustomerOwned && (
          <CustomerOwned
            device={device}
            hasNoLeasedDevice={hasNoLeasedDevice}
          />
        )}
      </div>
    ))}
  </div>
);

export default SwapOptionGroup;
